import { memo, forwardRef } from 'react';
import cc from 'classnames';
import { makeStyles } from 'hooks';
import moment from 'moment';
import { Typography, Grid, Card, CardContent, Tooltip } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  cardListItem: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    height: '100%'
  },
  cardListItemContent: {
    flexGrow: 1
  },
  date: {
    textAlign: 'center',
    width: theme.spacing(4),
    marginRight: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      marginRight: theme.spacing(2)
    }
  },
  day: {
    margin: '-4px 0',
    lineHeight: 1.3
  },
  noWrap: {
    flexWrap: 'nowrap'
  }
}));

export const CardListItem = memo(forwardRef(function CardListItem({ className, ...other }, ref) {
  const classes = useStyles();
  return <Card ref={ref} className={cc(classes.cardListItem, className)} elevation={2} {...other} />;
}));

export const CardListItemContent = memo(forwardRef(function CardListItemContent({ className, ...other }, ref) {
  const classes = useStyles();
  return <CardContent ref={ref} className={cc(classes.cardListItemContent, className)} {...other} />;
}));

export const CardDetails = memo(forwardRef(function CardDetails({ title, value, valueName, value2, noTitle }, ref) {
  const classes = useStyles();
  return <Grid ref={ref} container className={classes.noWrap} spacing={2} alignItems="center">
    <Grid item>
      {title}:
    </Grid>
    <Grid item zeroMinWidth xs>
      { !noTitle && <Tooltip title={valueName || value || ''} placement="bottom-end"><Typography component="div" align="right" noWrap>{value}</Typography></Tooltip> }
      { !!noTitle && <Typography component="div" align="right" noWrap>{value}</Typography> }
    </Grid>
    { value2 && <Grid item><Typography>{value2}</Typography></Grid> }
  </Grid>;
}));

export const ListDate = memo(forwardRef(function ListDate({ date }, ref) {
  const classes = useStyles();
  const d = date ? moment(date) : null;
  return <time ref={ref} className={classes.date} dateTime={d ? d.format('yyyy-MM-DD') : undefined}>
    <Typography variant="subtitle1" role="none">{d ? d.format('MMM') : ' '}</Typography>
    <Typography variant="h6" role="none" className={classes.day}>{d ? d.date() : '-'}</Typography>
    <Typography variant="caption">{d ? d.year() : ' '}</Typography>
  </time>;
}));